module.exports = __webpack_public_path__ + "static/img/fog.7b9c532.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/neutral/fog.png
// module id = rLoI
// module chunks = 0